var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.975 12.1852L21.2638 16.265C20.6868 19.5744 17.692 22 14.1827 22H9.00626C9.00418 22 9.00209 22 9 22H3C2.44772 22 2 21.5523 2 21V11C2 10.4477 2.44772 10 3 10H7.29282C7.37423 9.88171 7.47155 9.77309 7.58339 9.67749L9.03367 8.43769C9.70656 7.86246 10.3539 7.24017 10.7726 6.46262C11.0591 5.93045 11.2814 5.36723 11.434 4.78374L11.9135 2.94989C12.0063 2.59473 12.2569 2.29611 12.5994 2.13239C12.9105 1.98365 13.2707 1.95918 13.6007 2.06435L13.7469 2.11093C14.2929 2.28495 14.7081 2.71364 14.8478 3.24752C15.0163 3.892 15.0473 4.56435 14.9387 5.22142L14.2708 9.26598C14.187 9.77328 14.5811 10.2342 15.0988 10.2342H20.3214C21.3627 10.2342 22.1526 11.1662 21.975 12.1852Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpAlt);
export default __webpack_public_path__ + "static/media/thumbs-up-alt.783d456cbafed260b54a295f23c35395.svg";
export { ForwardRef as ReactComponent };